// eslint-disable-next-line import/prefer-default-export
export function getVariants(blueprint, handle) {
    return new Promise((resolve) => {
        const storefrontUrl = blueprint.custom['baa-shopify-storefront'];
        const accessKey = blueprint.custom['baa-shopify-access-token'];

        const query = {
            query: `
                query($handle: String!) {
                    product(handle: $handle) {
                        variants(first: 100) {
                            edges {
                                node {
                                    id
                                    sku
                                    quantityAvailable
                                    price {
                                        amount
                                        currencyCode
                                    }
                                }
                            }
                        }
                    }
                }
                `,
            variables: {
                handle,
            },
        };

        fetch(storefrontUrl, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': accessKey,
            },
            body: JSON.stringify(query),
        })
            .then((response) => response.json())
            .then((data) => {
                const all = [];

                data?.data?.product?.variants?.edges?.forEach((variant) => {
                    if (variant.node && variant.node?.price?.amount) {
                        all.push({
                            id: variant.node?.id,
                            sku: variant.node?.sku,
                            ats: variant.node?.quantityAvailable,
                            price: parseFloat(variant.node.price.amount),
                            currency: variant.node.price.currencyCode,
                        });
                    }
                });

                resolve(all);
            });
    });
}
